<template>
  <div class="container">
    <div style="font-weight: 600; margin-bottom: 20px">
      本年累计折扣优惠金额：
      <span style="color: #f34f20; margin-right: 30px">{{
        discountPriceTotal
      }}</span>
      本年剩余可优惠金额：
      <span style="color: #f34f20">{{ discountPriceSurplus }}</span>
    </div>
    <div style="border: solid 1px #c9cbd6">
      <el-table ref="multipleTable"
                v-loading="tableLoading"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }">
        <el-table-column label="订单编号"
                         prop="order_sn"></el-table-column>
        <el-table-column label="下单时间"
                         prop="create_time"></el-table-column>
        <el-table-column label="订单金额(含运费)"
                         prop="pay_money"></el-table-column>
        <el-table-column label="药品金额"
                         prop="drug_price"></el-table-column>

        <el-table-column label="折扣优惠金额"
                         prop="discount_price"></el-table-column>
        <el-table-column label="处方编号"
                         prop="pre_id"></el-table-column>

        <el-table-column label="交易状态">
          <template slot-scope="scope">
            <span v-if="scope.row.order_status == 1 || scope.row.order_status == 2">待发货</span>
            <span v-if="scope.row.order_status == 3">待收货</span>
            <span v-if="scope.row.order_status == 4">已完成</span>
            <span v-if="scope.row.order_status == 5">已取消</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="toDetail(scope.row.pre_id)"
                       :disabled="module_id_array[0]?!module_id_array.includes('56'):false"
                       type="text">查看处方</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="text-align:center">
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="10"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="totalNum"
                     style="margin: 20px 0"></el-pagination>
    </div>
  </div>
</template>
<script>
import platform from '../../../api/platform';
import order from '../../../api/order';

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      discountPriceTotal: '',
      discountPriceSurplus: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取认证记录列表
    getLogList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        user_id: this.$route.query.user_id
      };
      this.tableLoading = true;
      order
        .getOrderList(data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = platform.timestampToTime(item.create_time);
              return item;
            });
            this.totalNum = res.data.total;
            this.discountPriceTotal = res.data.discountPriceTotal;
            this.discountPriceSurplus = res.data.discountPriceSurplus;
            this.tableLoading = false;
          }
        })
        .catch((err) => {
          this.tableLoading = false;
          console.log(err);
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getLogList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getLogList();
    },
    toDetail(pre_id) {
      this.$router.push({
        path: '/home/yewu/chufangdetail',
        query: {
          pre_id
        }
      });
    }
  },
  created() {
    this.getLogList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  text-align: left;
  padding: 20px;
  box-sizing: border-box;
}
</style>